<template>
  <div :class="{ 'do-drag': !composite }">
    <div
      :class="[composite ? 'composite-title' : 'survey-title']"
      v-html="questionData.question[lang]"
      :style="{ color: color }"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    questionData: {
      type: Object
    },
    lang: {
      type: String,
      default: "pt_BR"
    },
    color: {
      type: String
    },
    status: {
      type: Number,
      default: 1
    },
    composite: Boolean
  },
  data() {
    return {};
  },

  methods: {}
};
</script>
<style scoped>
.survey-title {
  font-weight: 300;
  font-size: 20px;
  line-height: 1.4;
  color: #354052;
}
.composite-title {
  font-size: 16px;
  line-height: 20px;
  color: #354052;
  margin: 0;
  display: flex;
  align-items: center;
}
</style>
